export const SHOW_INFO_SAVE_DETAIL = 'api/job/show-info';
export const SHOW_INFO_COMPLETE_DETAIL = 'api/job/job-status';

